import React, { useCallback, useEffect } from "react";

import { document } from "../global";

type EventType = "keyup" | "keydown";

export default function useGlobalKeyboardEvent(
  key: string,
  onEvent: () => void,
  eventType: EventType = "keyup"
) {
  const handleEvent = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === key) {
        e.preventDefault();
        e.stopPropagation();
        onEvent();
      }
    },
    [key, onEvent]
  );

  useEffect(
    () => {
      document.addEventListener(eventType, handleEvent);
      return () => document.removeEventListener(eventType, handleEvent);
    },
    [eventType, handleEvent]
  );
}
